import config from '../config/environment';
import supabase from '../config/supabase';

export interface CoachOption {
  id: number;
  label: string;
  portal_user_id: number;
}

interface ListCoachesResponse {
  data?: CoachOption[];
  currentPortalUserId?: number | null;
  error?: string;
}

class CoachServiceClass {
  private async fetchList(): Promise<ListCoachesResponse> {
    const { data: sessionData } = await supabase.auth.getSession();
    const token = sessionData?.session?.access_token;

    if (!token) {
      throw new Error('Usuária não autenticada. Faça login novamente.');
    }

    const response = await fetch(`${config.supabaseFunctionsUrl}/list-coaches`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        apikey: config.supabaseAnonKey,
      },
    });

    const body = (await response.json().catch(() => ({}))) as ListCoachesResponse;

    if (!response.ok) {
      throw new Error(body.error || 'Erro ao carregar professoras.');
    }

    return body;
  }

  async listOptions(): Promise<CoachOption[]> {
    const body = await this.fetchList();
    return body.data ?? [];
  }

  async listViewer(): Promise<{ options: CoachOption[]; currentPortalUserId: number | null }> {
    const body = await this.fetchList();
    const currentPortalUserId = Number(body.currentPortalUserId);
    return {
      options: body.data ?? [],
      currentPortalUserId: Number.isInteger(currentPortalUserId) && currentPortalUserId > 0
        ? currentPortalUserId
        : null,
    };
  }
}

export const CoachService = new CoachServiceClass();
